import { render, staticRenderFns } from "./EditLandingSalesPerson.vue?vue&type=template&id=fe16d8b6&scoped=true&lang=pug&"
import script from "./EditLandingSalesPerson.vue?vue&type=script&lang=js&"
export * from "./EditLandingSalesPerson.vue?vue&type=script&lang=js&"
import style0 from "./EditLandingSalesPerson.vue?vue&type=style&index=0&id=fe16d8b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe16d8b6",
  null
  
)

/* custom blocks */
import block0 from "./EditLandingSalesPerson.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VLayout,VRow})
